import React from "react";
import IconContainer from "@/components/ui/icon-container";
import {
  ProgressIndicator,
  ProgressIndicatorCompleted,
  ProgressIndicatorEmpty
} from "@dreamhub/designsystem/icons";
interface Props {
  isCurrentStage: boolean;
  isPreviousStage: boolean;
}

const WorkflowMenuItemIcon: React.FC<Props> = ({
  isCurrentStage,
  isPreviousStage
}) => {
  if (isCurrentStage || isPreviousStage)
    return (
      <IconContainer size="5" color={isCurrentStage ? "primary" : "secondary"}>
        {isCurrentStage ? (
          <ProgressIndicator />
        ) : (
          <ProgressIndicatorCompleted />
        )}
      </IconContainer>
    );
  return (
    <IconContainer size="5" color="tertiary">
      <ProgressIndicatorEmpty />
    </IconContainer>
  );
};

export default WorkflowMenuItemIcon;
